module.exports = __webpack_public_path__ + "media/images/img_pr_male_1-b3dd4779f597da7742579a8db43e3880.png";